/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { View } from 'react-native-web';
import { connect } from 'react-redux';

import ErrorMessage from 'Components/Common/ErrorMessage';
import LoadingScreen from 'Components/Skeletons/PageSkeleton';

import Actions from 'Redux/Actions';
import Selectors from 'Redux/Selectors';

import { IProductDetails } from 'Redux/slices/products/Entities';
import { IProduct } from '@ddot/AddToCartCommon/lib/entities';
import { RootState } from 'Redux/store';

import { css } from '@emotion/react';

import Fonts from 'Themes/fonts';
import Colors from 'Themes/colors';

import { Col, Container, Row } from 'reactstrap';

import getPaymentDetails from 'Redux/slices/cart/controllers/getPaymentDetails';
import Banner from './Components/Banner';
import CustomBreadcrumb from './Components/CustomBreadcrumb';
import ProductDetailsRow from './Components/ProductDetailsRow';
// import Reviews from './Components/Reviews';
// import SimilarItems from './Components/SimilarItems';

import FeaturedProduct from '../Home/Components/FeaturedProduct';

interface ComponentProps {
    loading: boolean;
    error: string;
    productDetails: IProductDetails | null;
    match: {
        params: { productId: string }
    };
    setProductDetails(productDetails: IProductDetails): void;
    productList: IProduct[];
    setProductDetailsError(error: string): void;
    setProductDetailsAttempt(): void;
}

const ProductDetails = (props: ComponentProps): JSX.Element => {
    const { loading, error, productDetails, match: { params: { productId } }, setProductDetails, productList, setProductDetailsError, setProductDetailsAttempt } = props;

    useEffect(() => {
        setProductDetailsAttempt();
        if (productList.length) {
            const thisProduct = productList.find(product => product.id === productId);
            if (thisProduct) setProductDetails({ product: thisProduct });
            if (!thisProduct) setProductDetailsError('Product does not exist, please try again');
        }
    }, [productId, productList]);

    const renderProducts = () => {
        const thisProduct = productList.find(product => product.id === productId);
        const products = productList.filter(product => product.categoryId === thisProduct?.categoryId);

        const start = products.length > 4 ? Math.floor(Math.random() * (products.length - 3)) : 0;
        const end = start + 4;

        return products.slice(start, end).map(item => (
            <Col xs={6} sm={4} md={3} key={item.id} css={styles.featured}>
                <FeaturedProduct product={item} type='list' />
            </Col>
        ));
    };

    const renderBody = () => {
        if (loading) return <LoadingScreen />;
        if (error) return <ErrorMessage error={error} />;
        if (!productDetails) return false;

        return (
            <div style={{ marginBottom: 30, marginTop: 80 }}>
                <ProductDetailsRow
                    productDetails={productDetails}
                />
            </div>
        );
    };

    return (
        <View>
            <Banner />
            {/* <CustomBreadcrumb /> */}
            {renderBody()}
            <Container fluid css={styles.container}>
                <div css={styles.title}>You may also like</div>
                <Row xs={1} sm={4} md={5} style={{ marginTop: 20 }}>
                    {renderProducts()}
                </Row>
            </Container>
        </View>
    );
};

const mapStateToProps = (state: RootState) => ({
    loading: Selectors.getProductDetailsAttempting(state),
    error: Selectors.getProductDetailsError(state),
    productDetails: Selectors.getProductDetails(state),
    productList: Selectors.getProductsList(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    setProductDetailsAttempt: () => dispatch(Actions.setProductDetailsAttempt()),
    setProductDetails: (productDetails: IProductDetails) => dispatch(Actions.setProductDetails(productDetails)),
    setProductDetailsError: (error: string) => dispatch(Actions.setProductDetailsError(error)),
});

const styles = {
    container: css({
        '@media(min-width:300px)': {
            paddingTop: 50,
            paddingBottom: 20,
            paddingLeft: '10%',
            paddingRight: '10%',
            backgroundColor: Colors.white,
            border: '1px',
            borderWidth: 1,
            borderColor: Colors.border,
            textAlign: 'center',
            marginTop: 10,
        },

        '@media(min-width:992px)': {
            paddingLeft: '15%',
            paddingRight: '15%',
        },

        '@media(min-width:1200px)': {
            paddingTop: 100,
            paddingBottom: 120,
            paddingLeft: '10%',
            paddingRight: '10%',
            backgroundColor: Colors.white,
            border: '1px',
            borderWidth: 1,
            borderColor: Colors.border,
            textAlign: 'center',
            marginTop: 10,
        },
    }),
    title: css({
        fontFamily: 'Playfair',
        fontSize: '3rem',
        color: 'black',
        textAlign: 'start',
        fontWeight: 'bold',
        letterSpacing: 1,
        transform: 'scale(1, 0.9)',
    }),
    pageHeader: css({
        '@media(min-width:300px)': {
            position: 'relative',

            '& div': {
                position: 'absolute',
                top: '35%',
                left: '10%',
                '& p': {
                    color: 'white',
                    fontSize: '3.5rem',
                    fontWeight: 700,
                    letterSpacing: 2,
                    transform: 'scale(1, 0.9)',
                },
            },
        },

        '@media(min-width:1200px)': {
        },
    }),
    featured: css({
        '@media(min-width:300px)': {
            padding: 0,
        },

        '@media(min-width:1200px)': {
            padding: 40,
        },
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
